import { createFileRoute } from "@tanstack/react-router";
import { AtlasVsNotebookLMGuideFr, NOTEBOOKLM_META } from "@/pages/resources/AtlasVsNotebookLMGuide";

const { title, description, headline } = NOTEBOOKLM_META.fr;
const url = "https://systematlas.fr/fr/learn/atlas-vs-notebooklm";
const en = "https://systematlas.fr/learn/atlas-vs-notebooklm";

export const Route = createFileRoute("/fr/learn/atlas-vs-notebooklm")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "article" },
      { property: "og:url", content: url },
      { name: "twitter:card", content: "summary" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: description },
    ],
    links: [
      { rel: "canonical", href: url },
      { rel: "alternate", hrefLang: "en", href: en },
      { rel: "alternate", hrefLang: "fr", href: "https://systematlas.fr/fr/learn/atlas-vs-notebooklm" },
      { rel: "alternate", hrefLang: "x-default", href: en },
    ],
    scripts: [{ type: "application/ld+json", children: JSON.stringify({
      "@context": "https://schema.org", "@type": "Article", headline, description,
      datePublished: "2026-10-23", dateModified: "2026-10-23", inLanguage: "fr",
      author: { "@type": "Organization", name: "System Atlas", url: "https://systematlas.fr" },
      publisher: { "@type": "Organization", name: "System Atlas", url: "https://systematlas.fr" },
      mainEntityOfPage: url,
    }) }],
  }),
  component: AtlasVsNotebookLMGuideFr,
});
